import valid from "card-validator";

export const OnRampSupportedCardTypes = ["mastercard", "visa"];
export const OffRampSupportedCardTypes = ["mastercard", "visa"];

const cardTypeMapping = {
  mastercard: "Master",
  visa: "Visa",
  // mir: "Mir",
  // "diners-club": "Diners",
  // discover: "Discover",
};
const cardLogoMapping = {
  mastercard: require("@/assets/images/paymentMethod/master-saved-icon.svg"),
  visa: require("@/assets/images/paymentMethod/visa-saved-icon.svg"),
  // mir: require("@/assets/images/paymentMethod/mir-check.svg"),
  // "diners-club": require("@/assets/images/paymentMethod/diner.svg"),
  // discover: require("@/assets/images/paymentMethod/discover.png"),
};

export const getCardInfobyCardNumber = (cardNumber, type) => {
  const { isValid, card } = valid.number(cardNumber);
  if (isValid) {
    return {
      cardType: cardTypeMapping[card.type],
      cardLogo: cardLogoMapping[card.type],
      originalType: card.type,
    }[type];
  }
  return "";
};

export const isSupportedCardTypes = (cardNumber, businessType = "OnRamp") => {
  const originalType = getCardInfobyCardNumber(cardNumber, "originalType");
  if (businessType === "OnRamp") {
    return OnRampSupportedCardTypes.includes(originalType);
  } else {
    return OffRampSupportedCardTypes.includes(originalType);
  }
};
